// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToggleSwitcher__root--o3Wu {
    position: relative;
    display: inline-block;
    width: 74px;
    height: 32px;
}

    .ToggleSwitcher__root--o3Wu input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .ToggleSwitcher__root--o3Wu input:checked + .ToggleSwitcher__slider--Q3Im {
        background-color: var(--main-color);
        color: var(--tertiary-color);
    }

    .ToggleSwitcher__root--o3Wu input:checked + .ToggleSwitcher__slider--Q3Im > span {
            transform: translateX(-22px);
        }

    .ToggleSwitcher__root--o3Wu input:checked + .ToggleSwitcher__slider--Q3Im:before {
        transform: translateX(42px);
    }

.ToggleSwitcher__slider--Q3Im {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--obscure-color);
    color: var(--secondary-color);
    font-weight: 700;
    font-size: 12px;
    line-height: 32px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    transition: background-color 0.4s linear;
    border-radius: 26px;
    padding: 0 16px;
}

.ToggleSwitcher__slider--Q3Im > span {
        display: block;
        width: 100%;
        text-align: right;
        transition: color 0.4s linear, transform 0.4s linear;
    }
  
.ToggleSwitcher__slider--Q3Im:before {
    position: absolute;
    content: "";
    height: 28px;
    width: 28px;
    border-radius: 50%;
    left: 2px;
    bottom: 2px;
    background-color: var(--tertiary-color);
    transition: transform 0.4s linear;
    z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/ToggleSwitcher/ToggleSwitcher.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAoBhB;;IAlBI;QACI,UAAU;QACV,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,mCAAmC;QACnC,4BAA4B;IAKhC;;IAHI;YACI,4BAA4B;QAChC;;IAGJ;QACI,2BAA2B;IAC/B;;AAGJ;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sCAAsC;IACtC,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,wCAAwC;IACxC,mBAAmB;IACnB,eAAe;AAQnB;;AANI;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,oDAAoD;IACxD;;AAGJ;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uCAAuC;IACvC,iCAAiC;IACjC,UAAU;AACd","sourcesContent":[".root {\n    position: relative;\n    display: inline-block;\n    width: 74px;\n    height: 32px;\n\n    input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    input:checked + .slider {\n        background-color: var(--main-color);\n        color: var(--tertiary-color);\n\n        & > span {\n            transform: translateX(-22px);\n        }\n    }\n      \n    input:checked + .slider:before {\n        transform: translateX(42px);\n    }\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--obscure-color);\n    color: var(--secondary-color);\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 32px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    transition: background-color 0.4s linear;\n    border-radius: 26px;\n    padding: 0 16px;\n\n    > span {\n        display: block;\n        width: 100%;\n        text-align: right;\n        transition: color 0.4s linear, transform 0.4s linear;\n    }\n}\n  \n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 28px;\n    width: 28px;\n    border-radius: 50%;\n    left: 2px;\n    bottom: 2px;\n    background-color: var(--tertiary-color);\n    transition: transform 0.4s linear;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ToggleSwitcher__root--o3Wu`,
	"slider": `ToggleSwitcher__slider--Q3Im`
};
export default ___CSS_LOADER_EXPORT___;
